// Existing feature imports share the same accessible dialog shell.
export { default } from "../../components/ui/Modal";
